import { Injectable, } from '@angular/core';
import { catchError, map, retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpClientModule,HttpHeaders,HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlPreviewResponse } from '../models/gl-preview.model';


@Injectable({
	providedIn: 'root'
})

export class VendorService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	user: any = [];
	package: any = '';

	constructor(private globalSearchService: GlobalSearchService, private http: HttpClient,private _configSvc: RuntimeConfigLoaderService) {
		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});
		// Prime from BehaviorSubject so getApiKey() has user before first emission in edge cases
		this.user = this.globalSearchService.user.value ?? this.user;

		this.globalSearchService.configsubscription.subscribe((result: any) => {
			this.config = result;
		});
	}


	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type':	'application/json',
		})
	};


	public vendorService(id: any) {

	}

	public searchVendorHistory(data: any) {
		const method = 'vendor/history';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public getAge() {
		const method = 'vendor/ageing';
		return this.http.get(this.setEndPoint(method));
	}

	public getDashBoard() {
		const method = 'vendor/dashboard';
		return this.http.get(this.setEndPoint(method));
	}

	public getTop100Vendors(data: any) {
		const method = 'vendor/top100';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public checkInvoiceReference(supplierid: string, reference: string) {
		const method = 'vendor/invoice/checkreference&supplierid=' + encodeURIComponent(supplierid) + '&reference=' + encodeURIComponent(reference);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public checkCreditReference(supplierid: string, reference: string) {
		const method = 'vendor/credit/checkreference&supplierid=' + encodeURIComponent(supplierid) + '&reference=' + encodeURIComponent(reference);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public createInvoice(invoicedata: any) {
		const method = 'vendor/invoice/create';
		return this.http.post(this.setEndPoint(method), invoicedata, this.httpOptions).pipe(
			catchError(this.handleError(method, invoicedata))
		);
	}

	public previewInvoiceGl(payload: any) {
		const method = 'vendor/invoice/glpreview';
		return this.http.post<GlPreviewResponse>(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	public createCredit(data: any) {
		const method = 'vendor/credit/create';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public previewCreditGl(payload: any) {
		const method = 'vendor/credit/glpreview';
		return this.http.post<GlPreviewResponse>(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	public createReturn(data: any) {
		const method = 'vendor/return/create';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public updateVendorContacts(settings: any) {
		const method = 'vendor/updatevendorcontacts';
		return this.http.post(this.setEndPoint(method), settings, this.httpOptions).pipe(catchError(this.handleError(method, settings))
		);
	}
	public updateVendorNotes(settings: any) {
		const method = 'vendor/updatenotes';
		return this.http.post(this.setEndPoint(method), settings, this.httpOptions).pipe(catchError(this.handleError(method, settings))
		);
	}

	public updateVendor(input: any) {
		const method = 'vendor/update';
		return this.http.post(this.setEndPoint(method), { vendordata: input }, this.httpOptions).pipe(
			catchError(this.handleError(method))
		);
	}

	public getVendor(vendorid: any) {
		const method = 'vendor/read&supplierid='+vendorid;
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorTransactions(data: any) {
		const method = 'vendor/transactions';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError(method, data))
		);
	}

	public reverseTransaction(transid: any, reason: any) {
		const method = 'purchasing/reversal';
		const userid = this.getEffectiveUserid();
		return this.http.post(this.setEndPoint(method), { transid: transid, reason: reason, userid: userid }, this.httpOptions).pipe(
			catchError(this.handleError(method, { transid: transid }))
		);
	}

	/** Same source as vendor invoice/credit; URL query userid must stay in sync for APIs that only read GET. */
	private getEffectiveUserid(): string {
		try {
			const u = this.globalSearchService.user?.value ?? this.user;
			if (u && typeof u === 'object' && !Array.isArray(u)) {
				const fromNested = u.user?.userid;
				if (fromNested != null && String(fromNested).trim() !== '') {
					return String(fromNested).trim();
				}
				if (u.userid != null && String(u.userid).trim() !== '') {
					return String(u.userid).trim();
				}
				if (u.user_id != null && String(u.user_id).trim() !== '') {
					return String(u.user_id).trim();
				}
			}
			if (typeof localStorage !== 'undefined') {
				const raw = localStorage.getItem('user');
				if (raw) {
					const p = JSON.parse(raw);
					if (p?.user?.userid != null && String(p.user.userid).trim() !== '') {
						return String(p.user.userid).trim();
					}
					if (p?.userid != null && String(p.userid).trim() !== '') {
						return String(p.userid).trim();
					}
				}
			}
		} catch {
			/* ignore */
		}
		return '';
	}

	public getDailyTransactions(data: any) {
		const method = 'vendor/getdailytransactions';
		return this.http.post(this.setEndPoint(method), data, this.httpOptions).pipe(
			catchError(this.handleError('vendor/getdailytransactions', data))
		);
	}

	/**
	 * Active vendors only unless options.inc_disabled. Prefer getVendorsPost for full control.
	 */
	public getVendors(options?: { inc_disabled?: boolean }) {
		return this.getVendorsPost({
			inc_disabled: options?.inc_disabled === true,
		});
	}

	/** vendor/search POST: keywords optional; inc_disabled true includes suppliers.active = 0 */
	public getVendorsPost(data: { keywords?: string; inc_disabled?: boolean } = {}) {
		const method = 'vendor/search';
		const payload = {
			keywords: data.keywords != null ? String(data.keywords) : '',
			inc_disabled: data.inc_disabled === true,
		};
		return this.http.post(this.setEndPoint(method), payload, this.httpOptions).pipe(
			catchError(this.handleError(method, payload))
		);
	}

	public getVendorSearch(keywords: any, inc_disabled = false) {
		return this.getVendorsPost({
			keywords: keywords != null ? String(keywords) : '',
			inc_disabled: inc_disabled === true,
		});
	}

	public getVendorTypes() {
		const method = 'vendor/getvendortypes';
		return this.http.get(this.setEndPoint(method));
	}

	public getVendorItems(vendorid){
		 const method = 'vendor/purchdata&supplierid='+vendorid;
		 return this.http.get(this.setEndPoint(method));
	}

	public deleteVendor(vendorid){
		 const method = 'vendor/remove&supplierid='+vendorid;
		 return this.http.get(this.setEndPoint(method));
	}

	public saveVendor(vendordata){
		const method = 'vendor/save';
		return this.http.post(this.setEndPoint(method), { vendordata: vendordata }, this.httpOptions).pipe(
			catchError(this.handleError(method, vendordata))
		);
	}

	public uploadVendorAttachment(transId: number, payload: { content: string; name: string; mime: string }) {
		const method = 'vendor/attachment/upload';
		const body = { ...payload, transid: transId };
		const options = { ...this.httpOptions, timeout: 120000 };
		return this.http.post(this.setEndPoint(method), body, options).pipe(
			map((res: any) => {
				if (res && res.success !== true) {
					throw new Error('Attachment upload failed');
				}
				return res;
			}),
			catchError(this.handleError(method, body))
		);
	}

	public getVendorAttachments(transId: number) {
		const method = 'vendor/attachment/getList&transid=' + transId;
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public getVendorAttachmentDownloadUrl(attachmentId: number): string {
		return this.getApi() + 'vendor/attachment/download&id=' + attachmentId + this.getApiKey();
	}

	public getVendorAttachmentViewUrl(attachmentId: number): string {
		return this.getApi() + 'vendor/attachment/download&id=' + attachmentId + '&inline=1' + this.getApiKey();
	}

	public uploadVendorDocument(supplierid: string, payload: { content: string; name: string; mime: string }) {
		const method = 'vendor/documents/upload';
		const body = { ...payload, supplierid };
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	public getVendorDocuments(supplierid: string) {
		const method = 'vendor/documents/list&supplierid=' + encodeURIComponent(supplierid);
		return this.http.get(this.setEndPoint(method)).pipe(
			catchError(this.handleError(method, {}))
		);
	}

	public deleteVendorDocument(supplierid: string, idOrLink: number | string) {
		const method = 'vendor/documents/delete';
		const body = typeof idOrLink === 'number'
			? { id: idOrLink, supplierid }
			: { supplierid, link: idOrLink };
		return this.http.post(this.setEndPoint(method), body, this.httpOptions).pipe(
			catchError(this.handleError(method, body))
		);
	}

	private setEndPoint(method: any) {
		return this.getApi()+method+this.getApiKey()
	}

	private getApi() {
		return this.config.apiServer.endpoint;
	}

	private getApiKey() {
		const uid = encodeURIComponent(this.getEffectiveUserid());
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + uid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}

	public getKey() {
		return '&apikey='+this.key;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return throwError(() => error);
		};
	}
}
